import React from 'react';

import { Login } from '../containers';

const LoginRoute = () => {
  return (<Login />);
}

export default LoginRoute;
